// extracted by mini-css-extract-plugin
var _1 = "tjs-data-catalog__data-catalog tjs-_base__list-reset tjs-_base__scrollbars";
var _2 = "tjs-data-catalog__data-catalog tjs-_base__list-reset tjs-_base__scrollbars";
var _3 = "tjs-data-catalog__label tjs-_labels__label";
export { _1 as "data-catalog", _2 as "dataCatalog", _3 as "label" }
export default { "data-catalog": _1, "dataCatalog": _2, "label": _3 }
